import React from 'react'
import RoomInfo from './RoomInfo'
import styled from 'styled-components'

const MeetingShowContainer = ({
  room,
  onBack,
  showCancelAll,
  children,
  buttonBack
}) => {
  return (
    <Container>
      <RoomContainer>
        <RoomInfo room={room} />
      </RoomContainer>
      <StyledContainer>
        <div style={{width: '100%', height: 'calc(100vh - 210px)'}}>
          <StyledContainer>{children}</StyledContainer>
          <NavigationContainer>
            {showCancelAll && (
              <div>
                <CancelButton onClick={onBack}>{buttonBack}</CancelButton>
              </div>
            )}
          </NavigationContainer>
        </div>
      </StyledContainer>
    </Container>
  )
}

export default MeetingShowContainer

MeetingShowContainer.defaultProps = {
  showCancelAll: true
}

const Container = styled.div`
  display: grid;
  width: 100vw;
  height: calc(100vh - 80px);
  grid-template-rows: 1fr 80px;
  grid-template-columns: 540px calc(100vw - 540px);
  grid-template-areas: 'room schedule' 'room navigation';
  background-color: #eff0f3;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: 320px calc(100vw - 320px);
  }

  @media (max-width: 700px) {
    grid-template-rows: auto 1fr 80px;
    grid-template-columns: 100vw;
    grid-template-areas: 'room' 'schedule' 'navigation';
  }
`

const RoomContainer = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  grid-area: room;
`

const NavigationContainer = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;
  box-sizing: border-box;
  grid-area: navigation;
`

const CancelButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  width: 250px;
  margin-left: 20px;
  background-color: #a4a9b7;
  border: 2px solid #a4a9b7;
  color: #eff0f3;
  height: 46px;
  border-radius: 6px;
  outline: none;
`

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
`
